import { ConstantsTableColsEmissionsquelle } from "./constants-table-cols-emissionsquelle";

export class ConstantsTableColsStall extends ConstantsTableColsEmissionsquelle { 
    static readonly EMISSIONSMINDERUNGSMASSNAHME: string = 'EMISSIONSMINDERUNGSMASSNAHME';
    static readonly WIRKUNGSGRAD: string = 'WIRKUNGSGRAD'; 
    static readonly TIERART: string = 'TIERART';
    static readonly TIERKATEGORIE: string = 'TIERKATEGORIE';
    static readonly HALTUNGSVERFAHREN: string = 'HALTUNGSVERFAHREN';
    static readonly ANZAHL_TIERE: string = 'ANZAHL_TIERE';
    static readonly EINZELTIERMASSE_GV_TIER: string = 'EINZELTIERMASSE_GV_TIER';
    static readonly GESAMTTIERMASSE_GV: string = 'GESAMTTIERMASSE_GV';
    static readonly EMISSIONSFAKTOR_GE_GV: string = 'EMISSIONSFAKTOR_GE_GV';


    public static getColumns(): string[]
    {
      return [ 
        this.EDIT_REMOVE,
        this.BEZEICHNUNG,      
        this.TIERART,
        this.TIERKATEGORIE,
        this.HALTUNGSVERFAHREN,
        this.ANZAHL_TIERE,
        this.EINZELTIERMASSE_GV_TIER,
        this.GESAMTTIERMASSE_GV,
        this.EMISSIONSFAKTOR_GE_GV,
        this.EMISSIONSMINDERUNGSMASSNAHME,
        this.WIRKUNGSGRAD,
        this.GEWICHTUNGSFAKTOR,
        this.EMISSION_GE,            
        this.X_KOORDINATE,
        this.Y_KOORDINATE        
      ];
    }
  }
        